module.exports = __webpack_public_path__ + "static/media/iwu_logo.2b1b44c4.svg";